// components/Hero.js (Updated with background image)
import React from 'react';
import './Hero.css';
import { images } from '../utils/images';

const Hero = () => {
  return (
    <section 
      id="home" 
      className="hero"
      style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${images.hero})` }}
    >
      <div className="hero-content">
        <h1 className="hero-title">Empowering Communities, Changing Lives</h1>
        <p className="hero-subtitle">
          Join us in creating sustainable change through education, healthcare, and community development
        </p>
        <div className="hero-buttons">
          <button className="btn btn-primary">Get Involved</button>
          <button className="btn btn-secondary">Learn More</button>
        </div>
      </div>
    </section>
  );
};

export default Hero;